import React, { useEffect, useState,useContext,useRef } from 'react';
import AppContext from "../AppContext"
import { Row,Divider,Col,Space,Modal,Form,Select,Input,Upload,Button,Collapse,message,Typography,List, Popconfirm, Table } from 'antd';
import { GetTranslation } from '../../Models/shared/general';
import {
    onLoadAccoutItems,
    onUpdateAccountItems
} from '../../Controller/Management/PaymentManagement'

import IconButton from '@mui/material/IconButton';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';

import TextField from '@mui/material/TextField';

import Autocomplete from '@mui/material/Autocomplete';
import { DownloadOutlined,SearchOutlined,CheckOutlined,CloseOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';

import Backdrop from '@mui/material/Backdrop';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';

export default function PaymentItemManagement(prop) {

    const userlang                                              = navigator.language || navigator.userLanguage;

    const [Mpaymentitems, setMpaymentitems]                     = useState();
    const [Muserlist, setMuserlist]                             = useState();
    const [Mdepartmenlist, setMdepartmenlist]                   = useState();
    const [Mcombinedlist,setMcombinedlist]                      = useState();
    const [Mtype, setMtype]                                     = useState();
    
    const [ModalEditVisible, setModalEditVisible]               = useState(false)
    const [CreateForm,setCreateForm]                            = useState(true)
    const [Pobjid, setPobjid]                                   = useState('')
    const [Ppayitemid, setPpayitemid]                           = useState('')
    const [Ppayitemdesc, setPpayitemdesc]                       = useState('')
    const [Ppayitemtype, setPpayitemtype]                       = useState('')
    const [Papprover, setPapprover]                             = useState('')
    const [Pverify, setPverify]                                 = useState('')
    const [Pissue, setPissue]                                   = useState('')
    const [Pcomplete, setPcomplete]                             = useState('')
    const [Pexport, setPexport]                                 = useState('')
    
    const [opendialog,setopendialog]                            = useState(false)
    const [dialogtitle,setdialogtitle]                          = useState("")
    const [dialogstatus,setdialogstatus]                        = useState("")

    const [ProgressStatus, setPogressStatus]                    = useState(false);

    const [search, setSearch] = useState({ Text: "", Column: "" })

    const getColumnSearchProps = (dataIndex, title) => ({

        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>

                <Input
                   
                    autoFocus={true}
                    placeholder={`Search ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => {
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                        //handleSearch(e.target.value, confirm, dataIndex)
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            //setSelectedKeys(e.target.value ? [e.target.value] : [])
                            handleSearch(e.target.value, confirm, dataIndex)
                        }
                    }}
                    style={{ width: 200, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        data-reset='reset'
                        type="link"
                        onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? "crimson" : undefined }} />,

        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',

        render: (text) =>
            search.Column === dataIndex ?
                (
                    <Highlighter
                        highlightStyle={{ backgroundColor: "gold", padding: 0 }}
                        searchWords={[search.Text]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                )
                : (
                    text
                ),


    });
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm({ closeDropdown: false });
        setSearch({
            Text: selectedKeys,
            Column: dataIndex,
        });
     
    };
    const handleReset = clearFilters => {
        clearFilters({ closeDropdown: false });
        setSearch({ Column: search.Column, Text: '' });
    };

    function CheckDepartmentAndUserName(userid1,departmentlist,userlist)
    {

        let tempname = departmentlist.filter(x => x._id == userid1) 

        if(tempname.length == 0)
        {
            tempname = userlist.filter(x => x._id == userid1)[0].userid 
        }
        else
        {
            tempname = departmentlist.filter(x => x._id == userid1)[0].name 
        }

        return tempname
    }

    async function LoadPaymentItemListing()
    {
        var result = await onLoadAccoutItems({type : 'all'})

        var newlist = []
        var obj     = {}

        
        result.data.forEach((items) =>{
            obj = {}

            obj["_id"]              = items._id 
            obj["label"]            = items.actitemdesc 
            obj["value"]            = items.actitemid
            obj["actitemid"]        = items.actitemid
            obj["actitemdesc"]      = items.actitemdesc
            obj["acttype"]          = items.acttype
            obj["active"]           = items.active
            obj["1approve"]         = items["1approve"]
            obj["2verify"]          = items["2verify"]
            obj["3issue"]           = items["3issue"]
            obj["4confirm"]         = items["4confirm"]
            obj["5export"]          = items["5export"]

        
            obj["1approvename"]     = CheckDepartmentAndUserName(items["1approve"],result.departmentdata,result.userdata)
            obj["2verifyname"]      = CheckDepartmentAndUserName(items["2verify"],result.departmentdata,result.userdata)
            obj["3issuename"]       = CheckDepartmentAndUserName(items["3issue"],result.departmentdata,result.userdata)
            obj["4confirmname"]     = CheckDepartmentAndUserName(items["4confirm"],result.departmentdata,result.userdata)
            obj["5exportname"]      = CheckDepartmentAndUserName(items["5export"],result.departmentdata,result.userdata)
           
            newlist.push(obj)
        })

        const groupedTYPE = result.data.reduce((groups, item) => {
            const { acttype } = item;
            const key = `${acttype}`;
            if (!groups[key]) {
              groups[key] = { text :acttype,value :acttype,label:acttype };
            } else {
            }
            return groups;
          }, {});

          let temptype = Object.values(groupedTYPE)

          const groupedDepartment = result.departmentdata.reduce((groups, item) => {
            const { name ,_id} = item;
            const key = `${name,_id}`;
            if (!groups[key]) {
              groups[key] = { category :"Department",value :_id,label:name };
            } else {
            }
            return groups;
          }, {});

          let tempdepartment = Object.values(groupedDepartment)

          const groupedUser = result.userdata.reduce((groups, item) => {
            const { userid,_id } = item;
            const key = `${userid,_id}`;
            if (!groups[key]) {
              groups[key] = { category :"User ID",value :_id,label:userid };
            } else {
            }
            return groups;
          }, {});

          let tempuser = Object.values(groupedUser)


          let tempcombined = []

          for( var x = 0; x < tempdepartment.length; x++)
          {
              tempcombined.push(tempdepartment[x])
          }

          for( var x = 0; x < tempuser.length; x++)
          {
              tempcombined.push(tempuser[x])
          }
        setMtype(temptype)
        setMdepartmenlist(result.departmentdata)
        setMuserlist(result.userdata)
        setMpaymentitems(newlist)
        setMcombinedlist(tempcombined)

        
    }

    async function UpdatePaymentItemsStatus(data)
    {
        let temppaymentitems = Mpaymentitems

        setPogressStatus(true)
        let data1 = {
            actitemid           : data.actitemid,
            active              : !data.active
        }

      
        var result1 = await onUpdateAccountItems(data1)
       
        if(result1.status == 'ok')
        {
            
            setdialogtitle("Update Successfully!")
            setdialogstatus("success")
            setopendialog(true)
        }
        else
        {
            setdialogtitle("Update fail, please contact IT!")
            setdialogstatus("error")
            setopendialog(true)
        }
        temppaymentitems = temppaymentitems.map(x => x._id === data._id ? ({...x, active: !data.active} ) : (x))

        setPogressStatus(false)
        setMpaymentitems(temppaymentitems)
       
    }

    function handleModalOpen(data,type)
    {
        if(type == 1)
        {
            setCreateForm(true)
            setPpayitemid(data.actitemid)
            setPpayitemdesc(data.actitemdesc)
            setPpayitemtype(data.acttype)
            setPapprover({label :data["1approvename"], value :data['1approve']})
            setPverify({label :data["2verifyname"], value :data['2verify']})
            setPissue({label :data["3issuename"], value :data['3issue']})
            setPcomplete({label :data["4confirmname"], value :data['4confirm']})
            setPexport({label :data["5exportname"], value :data['5export']})
            
        }
        else if(type == 2)
        {
            setCreateForm(false)
            setPpayitemid('')
            setPpayitemdesc('')
            setPpayitemtype('')
            setPapprover('')
            setPverify('')
            setPissue('')
            setPcomplete('')
            setPexport('')
        }
      
        
        setModalEditVisible(true)
       
    }
    function handleModalClose(data)
    {
        setCreateForm(true)
        setPpayitemid('')
        setPpayitemdesc('')
        setPpayitemtype('')
        setPapprover('')
        setPverify('')
        setPissue('')
        setPcomplete('')

        setModalEditVisible(false)
    }

    async function handleModalSave()
    {

        if(Ppayitemid == undefined || Ppayitemid == null || Ppayitemid == '')
        {
            message.error("Please Key In Item ID !!")
            return
        }
        if(Ppayitemdesc == undefined || Ppayitemdesc == null || Ppayitemdesc == '')
        {
            message.error("Please Key In Description !!")
            return
        }
        if(Ppayitemtype == undefined || Ppayitemtype == null || Ppayitemtype == '')
        {
            message.error("Please Select Type !!")
            return
        }
      
         if(Papprover.value == undefined || Papprover.value == null || Papprover.value == '')
        {
            message.error("Please Select Approver !!")
            return
        }

        if(Pverify.value == undefined || Pverify.value == null || Pverify.value == '')
        {
            message.error("Please Select Verifier !!")
            return
        }

        if(Pissue.value == undefined || Pissue.value == null || Pissue.value == '')
        {
            message.error("Please Select Issuer !!")
            return
        }

             let data1 = {
            actitemid       : Ppayitemid,
            actitemdesc     : Ppayitemdesc,
            acttype         : Ppayitemtype,
            "1approve"      : Papprover.value,
            "2verify"       : Pverify.value,
            "3issue"        : Pissue.value,
            "4confirm"      : Pcomplete.value, //nicholas ID
            "5export"       : Pexport.value  //Finance Department ID
          
        }

        // "4confirm"      : '60ebde816d150ba31d16a879', //nicholas ID
        // "5export"       : '625537c0ef1c3ebee7debd69'  //Finance Department ID

        if(CreateForm == false)
        {
            data1.active = 1
        }

        setPogressStatus(true)
      
        var result1 = await onUpdateAccountItems(data1)

        if(result1.status == 'ok')
        {
            
            setdialogtitle("Update Successfully!")
            setdialogstatus("success")
            LoadPaymentItemListing()
            setopendialog(true)
            setModalEditVisible(false)

            setPpayitemid('')
            setPpayitemdesc('')
            setPpayitemtype('')
            setPapprover('')
            setPverify('')
            setPissue('')
            setPcomplete('')
            setPexport('')
        }
        else
        {
            setdialogtitle("Update fail, please contact IT!")
            setdialogstatus("error")
            setopendialog(true)
        }
        setPogressStatus(false)
        
    }
    function handleSnackClose()
    {
        setopendialog(false)
       
    }
    var paymentitemcolumn = 
    [
        {
            title: <div>Item ID</div>,
            dataIndex: 'actitemid',
            fixed: 'left',
            ...getColumnSearchProps('actitemid','actitemid'),
        },  
        {
            title: <div>Description</div>,
            dataIndex: 'actitemdesc',
            ...getColumnSearchProps('actitemdesc','actitemdesc'),
        },  
        {
            title: <div>Type</div>,
            dataIndex: 'acttype',
            filters:Mtype,
            onFilter: (value, record) => record.acttype.indexOf(value) === 0,
            
        },  
        {
            title: <div>Approver</div>,
            dataIndex: '1approvename',
            ...getColumnSearchProps('1approvename','1approvename'),
        },  
        {
            title: <div>Verifier</div>,
            dataIndex: '2verifyname',
            ...getColumnSearchProps('2verifyname','2verifyname'),
        },  
        {
            title: <div>Issuer</div>,
            dataIndex: '3issuename',
            ...getColumnSearchProps('3issuename','3issuename'),
        },  
        {
            title: <div>Complete</div>,
            dataIndex: '4confirmname',
            ...getColumnSearchProps('4confirmname','4confirmname'),
        },  
        {
            title: <div>Export</div>,
            dataIndex: '5exportname',
            ...getColumnSearchProps('5exportname','5exportname'),
        },  
        {
          title: '',
          dataIndex: 'operation',
          width: '10%',
          render: (_, record) =>
            <>
                <IconButton onClick={() => handleModalOpen(record,1)}>
                <EditIcon style={{color:"seagreen",fontSize:"xx-large"}}></EditIcon>
                </IconButton>
            {
                record.active == 1 ?
                <>
                <IconButton onClick={() => UpdatePaymentItemsStatus(record)}>
                <ToggleOffIcon style={{color:"seagreen",fontSize:"xx-large"}}></ToggleOffIcon>
                </IconButton>
                </>
                :
                <>
                <IconButton onClick={() => UpdatePaymentItemsStatus(record)}>
                <ToggleOnIcon style={{color:"red",fontSize:"xx-large"}}></ToggleOnIcon>
                </IconButton>
                </>
            }
          
            </>
        },
    ]

    const groupBy = (option) => option.category;

    useEffect(() => {
      
       
        LoadPaymentItemListing()
    
    },[])


    return (
        <>
        <Row justify="start">
            <div style={{width:"80%"}}>
            <Divider style={{paddingLeft:"10%"}}>{GetTranslation(userlang,prop.title) ?? "." }</Divider>
             </div>
             <div style={{width:"20%",display:"flex",alignItems:"center"}}>
                 <IconButton onClick={(val) => handleModalOpen('',2)}>
                 <AddCircleOutlineIcon style={{color:"blue"}}> 

                    </AddCircleOutlineIcon>
                 </IconButton>
                 
             </div>
           
        </Row>
        <Row>
            <div style={{width:"100%"}}>
            <Table
            bordered
            dataSource={Mpaymentitems}
            columns={paymentitemcolumn}
            size="small"
            pagination={false}
            >
                </Table>
            </div>
            
        </Row>

        <Modal
       visible={ModalEditVisible}
       title={"Edit"}
       onCancel={(val) =>handleModalClose()}
       footer={[
        <Button key="back" onClick={(val) =>handleModalClose()}>
          Return
        </Button>,
        <Button key="submit" type="primary" onClick={(val) => handleModalSave()}>
          Save
        </Button>,
       ]}
       >
        <Row>
            <div style={{width:"100%"}}>

           
            <div >
                <TextField
                style={{width:"100%"}}
                disabled={CreateForm}
                label="Item ID"
                value={Ppayitemid}
                onChange={(val1) => setPpayitemid(val1.target.value)}
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </div>
            <br/>
            <div >
                <TextField
                style={{width:"100%"}}
                label="Description"
                value={Ppayitemdesc}
                multiline={true}
                onChange={(val1) => setPpayitemdesc(val1.target.value)}
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </div>
            <br/>
            <div>
            <Autocomplete
            value={Ppayitemtype}
            onChange={(val1,val2) => setPpayitemtype(val2.value)}
            options={Mtype}
            isOptionEqualToValue={(option, value) => option.value === value}
            renderInput={(params) => <TextField {...params} label="Type" />}>
            </Autocomplete>
            </div>
            <br/>
            <div>
            <Autocomplete
            value={Papprover}
            onChange={(val1,val2) => setPapprover(val2)}
            options={Mcombinedlist}
            groupBy={groupBy}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            renderInput={(params) => <TextField {...params} label="Approver" />}>
            </Autocomplete>
            </div>
            <br/>
            <div>
            <Autocomplete
            value={Pverify}
            onChange={(val1,val2) => setPverify(val2)}
            options={Mcombinedlist}
            groupBy={groupBy}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            renderInput={(params) => <TextField {...params} label="Verifier" />}>
            </Autocomplete>
            </div>
            <br/>
            <div>
            <Autocomplete
            value={Pissue}
            onChange={(val1,val2) => setPissue(val2)}
            options={Mcombinedlist}
            groupBy={groupBy}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            renderInput={(params) => <TextField {...params} label="Issuer" />}>
            </Autocomplete>
            </div>
            <br/>
            <div>
            <Autocomplete
            value={Pcomplete}
            onChange={(val1,val2) => setPcomplete(val2)}
            options={Mcombinedlist}
            groupBy={groupBy}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            renderInput={(params) => <TextField {...params} label="Complete" />}>
            </Autocomplete>
            </div>
            <br/>
            <div>
            <Autocomplete
            value={Pexport}
            onChange={(val1,val2) => setPexport(val2)}
            options={Mcombinedlist}
            groupBy={groupBy}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            renderInput={(params) => <TextField {...params} label="Export" />}>
            </Autocomplete>
            </div>
            <br/>
            </div>
        </Row>

       </Modal>

        <Snackbar 
      anchorOrigin={{ vertical: "top", horizontal: "center" }} 
      open={opendialog} 
      autoHideDuration={6000} 
      onClose={handleSnackClose}>
        <Alert onClose={handleSnackClose} variant="filled" severity={dialogstatus}  sx={{ width: '100%' }}>
          {dialogtitle}
        </Alert>
      </Snackbar>
       <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={ProgressStatus}>
     
      <CircularProgress color="inherit" />
      </Backdrop>
        </>
    )
}